import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ManageBlogs() {
    const [title, setTitle] = useState('');
    const [paragraphs, setParagraphs] = useState(['']);
    const [image, setImage] = useState(null);
    const [showPostForm, setShowPostForm] = useState(true);
    const [blogs, setBlogs] = useState([]);

    const handleAddParagraph = () => {
        setParagraphs([...paragraphs, '']);
    };

    const handleParagraphChange = (index, value) => {
        const updatedParagraphs = [...paragraphs];
        updatedParagraphs[index] = value;
        setParagraphs(updatedParagraphs);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('title', title);

        paragraphs.forEach((paragraph, index) => {
            formData.append(`paragraphs[${index}]`, paragraph);
        });

        if (image) {
            formData.append('image', image);
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/postblog`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log('Blog submitted successfully:', response.data);

            setTitle('');
            setParagraphs(['']);
            setImage(null);
            fetchBlogs();
            setShowPostForm(false);
        } catch (error) {
            console.error('Error submitting blog:', error);
        }
    };

    const fetchBlogs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getblogs`); // Corrected endpoint
            setBlogs(response.data);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    const handleDeleteBlog = async (id) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/deleteblog/${id}`);
            if (response.status === 200) {
                alert(response.data.message); // Assuming your backend sends a { message: "..." } in the response
                fetchBlogs();
            } else {
                alert("Blog deletion failed. Please try again.");
            }
        } catch (error) {
            console.error('Error deleting blog:', error);
            alert("An error occurred while deleting the blog.");
        }
    };

    useEffect(() => {
        if (!showPostForm) {
            fetchBlogs();
        }
    }, [showPostForm]);

    return (
        <div className="p-8 bg-white rounded-lg shadow-md max-w-2xl mx-auto">
            <div className="flex justify-center space-x-4 mb-6">
                <button
                    className={`py-2 px-4 rounded-md ${showPostForm ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'
                        }`}
                    onClick={() => setShowPostForm(true)}
                >
                    Post Blog
                </button>
                <button
                    className={`py-2 px-4 rounded-md ${!showPostForm ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'
                        }`}
                    onClick={() => setShowPostForm(false)}
                >
                    Manage Blogs
                </button>
            </div>

            {showPostForm ? (
                <div>
                    <h2 className="text-3xl font-semibold text-gray-800 mb-6">Post Blog</h2>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
                                Title
                            </label>
                            <input
                                type="text"
                                id="title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-3"
                                placeholder="Enter blog title"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Content
                            </label>
                            {paragraphs.map((paragraph, index) => (
                                <textarea
                                    key={index}
                                    value={paragraph}
                                    onChange={(e) => handleParagraphChange(index, e.target.value)}
                                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-3 mb-2"
                                    placeholder={`Paragraph ${index + 1}`}
                                    rows="4"
                                />
                            ))}
                            <button
                                type="button"
                                onClick={handleAddParagraph}
                                className="bg-gray-200 hover:bg-gray-300 py-2 px-4 rounded-md text-sm mt-2"
                            >
                                Add Paragraph
                            </button>
                        </div>

                        <div>
                            <label htmlFor="image" className="block text-sm font-medium text-gray-700 mb-1">
                                Image
                            </label>
                            <input
                                type="file"
                                id="image"
                                onChange={handleImageChange}
                                accept="image/*"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-3"
                            />
                            {image && (
                                <div className="mt-4">
                                    <img src={URL.createObjectURL(image)} alt="Blog Preview" className="max-w-xs rounded-md" />
                                </div>
                            )}
                        </div>

                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-md text-lg font-semibold"
                            >
                                Submit Blog
                            </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div>
                    <h2 className="text-3xl font-semibold text-gray-800 mb-6">Manage Blogs</h2>
                    <div className="space-y-4">
                        {blogs.map((blog) => (
                            <div key={blog._id} className="border p-4 rounded-md shadow-md hover:shadow-lg transition-shadow duration-300">
                                <div className="flex justify-between items-start mb-4">
                                    <div>
                                        <h3 className="text-xl font-semibold text-gray-800">{blog.title}</h3>
                                        <p className="text-gray-600 mt-2">
                                            {blog.paragraphs[0] && blog.paragraphs[0].substring(0, 100)}...
                                        </p>
                                    </div>
                                    <button
                                        className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md text-sm"
                                        onClick={() => handleDeleteBlog(blog._id)}
                                    >
                                        Delete
                                    </button>
                                </div>
                                {blog.image && (
                                    <div className="mt-4">
                                        <img src={blog.image} alt="Blog" className="max-w-xs rounded-md" />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default ManageBlogs;